import { render, staticRenderFns } from "./DefaultLinksEditor.vue?vue&type=template&id=5e339f98&scoped=true&"
import script from "./DefaultLinksEditor.vue?vue&type=script&lang=js&"
export * from "./DefaultLinksEditor.vue?vue&type=script&lang=js&"
import style0 from "./DefaultLinksEditor.vue?vue&type=style&index=0&id=5e339f98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e339f98",
  null
  
)

export default component.exports